// 水印指令核心逻辑
export default {
  install(Vue) {
    // 定义默认配置
    const defaultProps = {
      text: {
        type: String,
        default: '默认水印 © 2026'
      },
      fontSize: {
        type: Number,
        default: 14
      },
      color: {
        type: String,
        default: 'rgba(0, 0, 0, 0.5)' // 🔴 提高透明度，方便测试
      },
      rotate: {
        type: Number,
        default: -15
      },
      gap: {
        type: Number,
        default: 80
      },
      enabled: {
        type: Boolean,
        default: true
      }
    }

    // 解析配置参数
    const getConfig = (binding) => {
      const config = {}
      Object.keys(defaultProps).forEach(key => {
        const prop = defaultProps[key]
        config[key] = binding.value?.[key] !== undefined ? binding.value[key] : prop.default
      })
      return config
    }

    // 绘制水印并应用到元素
    const bindWatermark = (el, binding) => {
      // 基础校验
      if (!el || !el.parentNode || !document.body.contains(el)) return;

      const config = getConfig(binding)
      if (!config.enabled) return

      // 🔴 修复1：确保Canvas绘制成功（兼容字体/空文本）
      if (!config.text) config.text = '默认水印' // 防止空文本导致Canvas无内容
      const canvas = document.createElement('canvas')
      const ctx = canvas.getContext('2d')
      if (!ctx) { // 极端情况Canvas不支持
        console.error('当前环境不支持Canvas，无法生成水印')
        return
      }

      // 设置Canvas尺寸（适配水印重复）
      canvas.width = config.gap * 2
      canvas.height = config.gap * 2
      
      // 🔴 修复2：Canvas绘制增强（防止绘制失败）
      ctx.clearRect(0, 0, canvas.width, canvas.height) // 清空画布
      ctx.font = `${config.fontSize}px Microsoft Yahei, Arial, sans-serif` // 兼容字体
      ctx.fillStyle = config.color
      ctx.rotate((config.rotate * Math.PI) / 180)
      ctx.textAlign = 'center'
      ctx.textBaseline = 'middle'
      ctx.fillText(config.text, canvas.width / 2, canvas.height / 2)

      const watermarkBase64 = canvas.toDataURL('image/png')
      console.log('水印base64生成成功:', watermarkBase64.substring(0, 50) + '...') // 调试

      // 🔴 修复3：统一使用遮罩层方案（兼容所有元素，包括img/容器）
      // 先清除旧遮罩
      const oldMask = el.parentNode.querySelector('.watermark-mask')
      if (oldMask) oldMask.remove()

      // 创建新遮罩层
      const mask = document.createElement('div')
      mask.className = 'watermark-mask' // 统一类名，方便管理
      mask.style.cssText = `
        position: absolute !important;
        top: 0 !important;
        left: 0 !important;
        width: 100% !important;
        height: 100% !important;
        pointer-events: none !important;
        background: url(${watermarkBase64}) repeat 0 0 !important;
        z-index: 9999 !important; // 确保遮罩在最上层
        background-size: ${config.gap * 2}px ${config.gap * 2}px !important; // 固定水印尺寸
      `

      // 🔴 修复4：强制设置父容器为相对定位（防止遮罩层跑偏）
      const parent = el.parentNode
      if (parent) {
        const parentPos = window.getComputedStyle(parent).position
        if (parentPos === 'static' || !parentPos) {
          parent.style.position = 'relative'
        }
        parent.appendChild(mask)
      }
    }

    // 全局指令 v-watermark
    Vue.directive('watermark', {
      // 绑定元素时执行
      bind(el, binding) {
        // 🔴 修复5：图片加载完成后再加水印（避免图片未加载遮罩层错位）
        if (el.tagName === 'IMG') {
          if (el.complete) { // 图片已加载完成
            bindWatermark(el, binding)
          } else { // 图片未加载，监听加载完成事件
            el.onload = () => bindWatermark(el, binding)
            el.onerror = () => console.warn('图片加载失败，无法添加水印:', el.src)
          }
        } else { // 非图片元素直接执行
          bindWatermark(el, binding)
        }
      },

      // 指令参数更新时执行
      update(el, binding) {
        try {
          bindWatermark(el, binding)
        } catch (e) {
          console.warn('水印更新失败:', e)
        }
      },

      // 组件销毁时清除水印
      unbind(el) {
        try {
          const mask = el.parentNode?.querySelector('.watermark-mask')
          if (mask) mask.remove()
        } catch (e) {
          console.warn('清除水印失败:', e)
        }
      }
    })

    // 全局方法：一键开启/关闭所有水印
    Vue.prototype.$toggleWatermark = function(enabled = true) {
      const allMasks = document.querySelectorAll('.watermark-mask')
      allMasks.forEach(mask => {
        mask.style.display = enabled ? 'block' : 'none'
      })
      // 同步更新指令配置（确保刷新后状态一致）
      const allWatermarkEls = document.querySelectorAll('[v-watermark]')
      allWatermarkEls.forEach(el => {
        try {
          const vueInstance = el.__vue__ || el._vueParentComponent
          if (!vueInstance) return
          const directives = vueInstance.$vnode?.data?.directives || []
          const watermarkDirective = directives.find(d => d.name === 'watermark')
          if (watermarkDirective) {
            watermarkDirective.value = { ...watermarkDirective.value, enabled }
          }
        } catch (e) {
          console.warn('更新水印配置失败:', e)
        }
      })
    }
  }
}